import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

/**
 * PriorityModal - Modal per selezionare il vincitore in caso di parità
 * 
 * Props:
 * - visible: boolean - se mostrare il modal
 * - onClose: () => void - callback per chiudere
 * - onConfirm: () => void - callback per confermare fine match
 * - onSelectPriority: (team: 'A' | 'B') => void - callback per assegnare priorità
 * - priorityTeam: 'A' | 'B' | null - squadra con priorità selezionata
 * - scoreA: number - punteggio squadra A
 * - scoreB: number - punteggio squadra B
 * - teamA: object - dati squadra A
 * - teamB: object - dati squadra B
 * - competitionType: string - tipo gara ('team', 'individual', 'mixed')
 */
const PriorityModal = ({
    visible = false,
    onClose,
    onConfirm,
    onSelectPriority,
    priorityTeam = null,
    scoreA = 0,
    scoreB = 0,
    teamA = null,
    teamB = null,
    competitionType = 'individual',
}) => {
    if (!visible) return null;

    const getTeamDisplayName = (team, teamData, fallback) => {
        if (competitionType === 'individual') {
            return teamData?.name || fallback;
        }
        return `Squadra ${teamData?.name || fallback}`;
    };

    return (
        <View style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.7)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 20
        }}>
            <View style={{
                backgroundColor: '#fff',
                borderRadius: 12,
                padding: 24,
                width: '90%',
                maxWidth: 500
            }}>
                <Text style={{ fontSize: 24, fontWeight: 'bold', color: '#1976d2', marginBottom: 16, textAlign: 'center' }}>
                    Punteggio in parità
                </Text>
                <Text style={{ fontSize: 16, color: '#555', marginBottom: 24, textAlign: 'center' }}>
                    Per terminare l'incontro è necessario selezionare manualmente il vincitore.
                </Text>

                <View style={{ flexDirection: 'row', justifyContent: 'space-around', marginBottom: 24 }}>
                    <Text style={{ fontSize: 24, fontWeight: 'bold', color: '#d32f2f' }}>
                        {scoreA} - {scoreB}
                    </Text>
                </View>

                {priorityTeam ? (
                    <View style={{ alignItems: 'center', marginBottom: 24 }}>
                        <Text style={{ fontSize: 18, color: '#555', marginBottom: 8 }}>
                            Vittoria assegnata a:
                        </Text>
                        <Text style={{
                            fontSize: 22,
                            fontWeight: 'bold',
                            color: priorityTeam === 'A' ? '#d32f2f' : '#388e3c',
                            backgroundColor: '#f5f5f5',
                            paddingVertical: 8,
                            paddingHorizontal: 16,
                            borderRadius: 8
                        }}>
                            {priorityTeam === 'A'
                                ? getTeamDisplayName('A', teamA, 'A')
                                : getTeamDisplayName('B', teamB, 'B')}
                        </Text>
                    </View>
                ) : (
                    <View style={{ flexDirection: 'row', justifyContent: 'space-around', width: '100%', marginBottom: 24 }}>
                        {/* Selezione squadra A (rossa) */}
                        <TouchableOpacity
                            onPress={() => onSelectPriority('A')}
                            style={{
                                backgroundColor: '#ffebee',
                                paddingVertical: 12,
                                paddingHorizontal: 16,
                                borderRadius: 8,
                                borderWidth: 2,
                                borderColor: '#d32f2f',
                                width: '45%',
                                alignItems: 'center'
                            }}
                        >
                            <Text style={{ color: '#d32f2f', fontWeight: 'bold', fontSize: 16, textAlign: 'center' }}>
                                {getTeamDisplayName('A', teamA, 'A')}
                            </Text>
                        </TouchableOpacity>

                        {/* Selezione squadra B (verde) */}
                        <TouchableOpacity
                            onPress={() => onSelectPriority('B')}
                            style={{
                                backgroundColor: '#e8f5e9',
                                paddingVertical: 12,
                                paddingHorizontal: 16,
                                borderRadius: 8,
                                borderWidth: 2,
                                borderColor: '#388e3c',
                                width: '45%',
                                alignItems: 'center'
                            }}
                        >
                            <Text style={{ color: '#388e3c', fontWeight: 'bold', fontSize: 16, textAlign: 'center' }}>
                                {getTeamDisplayName('B', teamB, 'B')}
                            </Text>
                        </TouchableOpacity>
                    </View>
                )}

                <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                    <TouchableOpacity
                        onPress={onClose}
                        style={{
                            backgroundColor: '#f5f5f5',
                            paddingVertical: 12,
                            paddingHorizontal: 24,
                            borderRadius: 8,
                            flex: 1,
                            marginRight: 12
                        }}
                    >
                        <Text style={{ color: '#555', fontWeight: 'bold', fontSize: 16, textAlign: 'center' }}>
                            Annulla
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                        onPress={onConfirm}
                        style={{
                            backgroundColor: priorityTeam ? '#2e7d32' : '#ccc',
                            paddingVertical: 12,
                            paddingHorizontal: 24,
                            borderRadius: 8,
                            flex: 1,
                            marginLeft: 12
                        }}
                        disabled={!priorityTeam}
                    >
                        <Text style={{ color: '#fff', fontWeight: 'bold', fontSize: 16, textAlign: 'center' }}>
                            Conferma Fine Match
                        </Text>
                    </TouchableOpacity>
                </View>
            </View>
        </View>
    );
};

export default PriorityModal;
